$( document ).on("turbo:load", function () {
  $('.deleteImage').each(function(index) {
    if (index < 2) {
      $(this).prop('disabled', true);
    }
  })

  $('.addImage').on('click', function () {
    var lastRepeatingGroup = $('.repeatingSection').last();
    var newSection = lastRepeatingGroup.clone();
    newSection.find('div#asset-container').remove();
    newSection.find('p').remove();
    newSection.find('.asset-preview').remove();
    newSection.find('.imageCaption').val('');

    var modalButton = newSection.find(".asset-manager-modal-button").eq(0);
    var lastId = modalButton.attr('id');
    var newId = parseInt(lastId, 10) + 1;

    modalButton.attr("id", newId);
    newSection.find("input").each(function (index, input) {
      input.id = input.id.replace("_" + lastId, "_" + newId);
      input.name = input.name.replace("[" + lastId, "[" + newId);
    });
    newSection.find('.deleteImage').prop('disabled', false);
    newSection.insertAfter(lastRepeatingGroup);

    return false;
  })

// Delete a repeating section
  $(document).on('click', '.deleteImage', function () {
    $(this).parent('div').remove();
  })
});
